export default __webpack_public_path__ + "static/media/cy.4edec3a0.svg";